// Analytics feature entry — reach, replies and conversions on one dashboard.
import { ChartColumn } from "lucide-react";
import type { FeatureModule } from "../registry";

const analytics: FeatureModule = {
  id: "analytics",
  nav: [{ to: "/analytics", label: "Analytics", icon: ChartColumn, group: "insights", order: 10 }],
  routes: [
    {
      path: "/analytics",
      lazy: async () => ({ Component: (await import("./AnalyticsPage")).AnalyticsPage }),
    },
  ],
};

export default analytics;
